import { useState } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import { serialize } from "../redux/utils/jsona";

const dataFormatter = new Jsona();

const validateOrdersApiService = async () =>
  new JsonApiService("orders", {
    baseUrl: `${visionURL}/admin_console/api/validate`,
    credentials: "include"
  });

export const useValidateOrders = () => {
  const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);
  return {
    getValidateOrder: async (id, { include = [], fields = {} } = {}) => {
      const service = await validateOrdersApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .find(id)
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },

    getValidateOrders: async ({
      page,
      orderBy,
      orderDirection,
      include = [],
      fields = {},
      filters
    }) => {
      const service = await validateOrdersApiService();
      const response = await service
        .page(page)
        .orderBy(orderBy)
        .orderDirection(orderDirection)
        .where(filters)
        .fields(fields)
        .include(include)
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },

    updateValidateOrder: async (
      id,
      data,
      { include = [], fields = {} } = {}
    ) => {
      setIsUpdatingOrder(true);
      const service = await validateOrdersApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .update(
          id,
          JSON.stringify(serialize({ ...data, type: "Validate::Order" }))
        )
        .then(response => response.json());
      setIsUpdatingOrder(false);

      if (response.error || response.errors) {
        throw response.error || response.errors;
      }

      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },
    isUpdatingOrder
  };
};
